import moment from 'moment';

export type MetricsRangeKey = '7d' | '30d' | '90d' | '1y' | 'custom';

export type MetricsPresetKey = Exclude<MetricsRangeKey, 'custom'>;

export type MetricsDateRange = { start: string | Date; end: string | Date };
export type MetricsApiDateRange = { start: string; end: string };

export const DEFAULT_RANGE_KEY: MetricsPresetKey = '7d';

const PRESET_DAYS: Record<MetricsPresetKey, number> = {
  '7d': 7,
  '30d': 30,
  '90d': 90,
  '1y': 365,
};

const toUtcDay = (value: Date) => moment.utc(value).startOf('day');

export function getPresetDateRange(key: MetricsPresetKey): { start: Date; end: Date } {
  const days = PRESET_DAYS[key];
  const end = moment.utc().startOf('day');
  const start = end.clone().subtract(days - 1, 'days');
  return { start: start.toDate(), end: end.toDate() };
}

export function formatDateRangeForApi(range: MetricsDateRange): MetricsApiDateRange {
  return {
    start: moment.utc(range.start).format('YYYY-MM-DD'),
    end: moment.utc(range.end).format('YYYY-MM-DD'),
  };
}

export function identifyPreset(start: Date, end: Date): MetricsRangeKey {
  const startDay = toUtcDay(start);
  const endDay = toUtcDay(end);

  if (!startDay.isValid() || !endDay.isValid()) {
    return 'custom';
  }

  const today = moment.utc().startOf('day');

  if (!endDay.isSame(today, 'day')) {
    return 'custom';
  }

  const spanDays = endDay.diff(startDay, 'days') + 1;
  const match = (Object.keys(PRESET_DAYS) as MetricsPresetKey[]).find(
    (key) => PRESET_DAYS[key] === spanDays,
  );

  return match ?? 'custom';
}
